var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.info.vid)?_c('div',{staticClass:"player container",attrs:{"id":"container"}}):_vm._e(),_c('div',{staticClass:"rich-text",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }